const FEATURES = Object.freeze({
  BMW_ONLINE_THERAPY_APPOINTMENT: 'bmw-online-therapy-booking',
  BMW_ONSITE_THERAPY_APPOINTMENT: 'bmw-onsite-therapy-booking',
  CHILD_THERAPIST_APPOINTMENT: 'child-therapist-appointment',
  CHILD_THERAPIST_APPOINTMENT_INTL: 'child-therapist-appointment-intl',
  CORPORATE_DIAGNOSTICS: 'corporate-diagnostics',
  DIETITIAN_APPOINTMENT: 'dietitian-appointment',
  DIETITIAN_APPOINTMENT_INTL: 'dietitian-appointment-intl',
  GROUP_THERAPY: 'group-therapy',
  KNOWLEDGE_BASE: 'knowledge-base',
  LACTATION_CONSULTATION_APPOINTMENT: 'lactation-consultation-appointment',
  LACTATION_CONSULTATION_APPOINTMENT_INTL:
    'lactation-consultation-appointment-intl',
  MENTAL_ACADEMY: 'mental-academy',
  MENTAL_ACADEMY_INTL: 'mental-academy-intl',
  MENTAL_WELLBEING_DIAGNOSTICS: 'mental-wellbeing-diagnostics',
  MYMEDIO_APPOINTMENT_BOOKING: 'mymedio-appointment-booking',
  ON_DEMAND_MEDICAL_DOCTOR: 'ondemand-md',
  ON_DEMAND_MEDICAL_DOCTOR_INTL: 'ondemand-md-intl',
  ON_DEMAND_PEDIATRICIAN: 'ondemand-pediatrician',
  ON_DEMAND_PEDIATRICIAN_INTL: 'ondemand-pediatrician-intl',
  PHARMACIST_APPOINTMENT: 'pharmacist-appointment',
  PHARMACIST_APPOINTMENT_INTL: 'pharmacist-appointment-intl',
  PHYSICAL_THERAPY_APPOINTMENT: 'physical-therapy-appointment',
  PHYSICAL_THERAPY_APPOINTMENT_INTL: 'physical-therapy-appointment-intl',
  RISK_ANALYSIS: 'risk-analysis',
  SYMPTOM_CHECK: 'symptom-check',
  THERAPIST_APPOINTMENT: 'therapist-appointment',
  THERAPIST_APPOINTMENT_INTL: 'therapist-appointment-intl',
  WEBINARS: 'webinars',
  WEBINARS_INTL: 'webinars-intl',
})

export { FEATURES }
